import { render, staticRenderFns } from "./ProcessStepsWizard.vue?vue&type=template&id=4f8ca608&scoped=true&"
import script from "./ProcessStepsWizard.vue?vue&type=script&lang=js&"
export * from "./ProcessStepsWizard.vue?vue&type=script&lang=js&"
import style0 from "./ProcessStepsWizard.vue?vue&type=style&index=0&id=4f8ca608&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8ca608",
  null
  
)

export default component.exports